'use client';

import { useState } from 'react';

import { Box, Collapse } from '@mui/material';

import { useQuery } from '@apollo/client/react';

import { graphql } from '@/gql';

import { Or2Alert } from '@/components/feedback/Or2Alert';
import { Or2Button } from '@/components/button/Or2Button';
import { Or2Dialog } from '@/components/feedback/Or2Dialog';
import { extractPaginationProps } from '@/utils/queries/queryExtracts';

import { PendingInvitesList } from '@/app/(main)/invitations/_components/PendingInvitesList';

const PENDING_INVITES_BANNER_QUERY = graphql(`
  query PendingInvitesBanner {
    currentUser {
      _id
      pendingMemberOfGroupsConnection {
        totalCount
        edges {
          node {
            ...pendingInvitesListGroupsFields
          }
        }
      }
    }
  }
`);

export const PendingInvitesBanner = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { data, loading } = useQuery(PENDING_INVITES_BANNER_QUERY);

  const { totalCount, nodes: groups } = extractPaginationProps(
    data?.currentUser?.pendingMemberOfGroupsConnection,
  );

  // Collapses itself when the last invite is accepted or declined, so callers
  // don't have to wrap it.
  return (
    <Collapse in={totalCount > 0} unmountOnExit>
      <Box sx={{ mb: 2 }}>
        <Or2Alert
          severity="info"
          variant="filled"
          sx={{ cursor: 'pointer' }}
          onClick={() => setDialogOpen(true)}
          action={
            <Or2Button
              size="small"
              variant="text"
              color="secondary"
              onClick={(e) => {
                e.stopPropagation();
                setDialogOpen(true);
              }}
            >
              View
            </Or2Button>
          }
        >
          You have{' '}
          {totalCount === 1
            ? '1 invite to join a board'
            : `${totalCount} invites to join boards`}
        </Or2Alert>
        <Or2Dialog
          open={dialogOpen}
          title="Board invitations"
          onClose={() => setDialogOpen(false)}
        >
          <PendingInvitesList loading={loading} groups={groups} />
        </Or2Dialog>
      </Box>
    </Collapse>
  );
};
